module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_child') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addVisible = true
      }
    }
  }, [_vm._v("添加推广员")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会员手机号"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": "",
      "height": _vm.wheight - 170,
      "element-loading-text": "数据加载中",
      "default-sort": {
        prop: 'bind_date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "promoter_grade_name",
      "min-width": "100",
      "label": "推广员等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pmobile",
      "label": "上级",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s((scope.row.pmobile && scope.row.pmobile != '') ? scope.row.pmobile : '-') + "\n        ")]
      }
    }], null, false, 2472365194)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "children_count",
      "min-width": "120",
      "label": "直属下级",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "edit",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.count(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.children_count))])]
      }
    }], null, false, 1414125171)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#efefef"
          },
          on: {
            "change": function($event) {
              return _vm.freeze(scope.row)
            }
          },
          model: {
            value: (scope.row.disabled == 0),
            callback: function($$v) {
              _vm.$set(scope.row, "disabled == 0", $$v)
            },
            expression: "scope.row.disabled == 0"
          }
        })]
      }
    }], null, false, 4123711519)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开店状态",
      "min-width": "65"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.shop_status === 0) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v(" 未开店 ")]) : _vm._e(), _vm._v(" "), (scope.row.shop_status === 1) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v(" 已开店 ")]) : _vm._e(), _vm._v(" "), (scope.row.shop_status === 2) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v(" 等待审核 ")]) : _vm._e(), _vm._v(" "), (scope.row.shop_status === 3) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "warning"
          }
        }, [_vm._v(" 店铺关闭 ")]) : _vm._e(), _vm._v(" "), (scope.row.shop_status === 4) ? _c('el-popover', {
          attrs: {
            "placement": "top-start",
            "width": "300",
            "trigger": "hover",
            "content": scope.row.reason
          }
        }, [_c('el-tag', {
          attrs: {
            "slot": "reference",
            "size": "mini",
            "effect": "plain"
          },
          slot: "reference"
        }, [_vm._v("审核拒绝")])], 1) : _vm._e()]
      }
    }], null, false, 3420465417)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bind_date",
      "label": "加入时间",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已结算",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s((scope.row.rebateTotal - scope.row.noCloseRebate) / 100))]
      }
    }], null, false, 4079155444)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "未结算",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.noCloseRebate / 100))]
      }
    }], null, false, 1366615743)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "260",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "size": "mini",
            "icon": "edit",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.detail(scope.row)
            }
          }
        }, [_vm._v("分佣详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "edit",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editTop(scope.row)
            }
          }
        }, [_vm._v("调整至顶级")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "edit",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editSuperior(scope.row)
            }
          }
        }, [_vm._v("调整上级")]), _vm._v(" "), (scope.row.shop_status === 0 || scope.row.shop_status === 4 || scope.row.shop_status === 3) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleShopStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v(" 开通虚拟店")]) : _vm._e(), _vm._v(" "), (scope.row.shop_status === 2) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleShopStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v(" 审核申请 ")]) : _vm._e(), _vm._v(" "), (scope.row.shop_status === 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleShopStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v(" 关闭虚拟店")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.gradeList.isOpenPromoterGrade == 'true'),
            expression: "gradeList.isOpenPromoterGrade == 'true'"
          }],
          attrs: {
            "size": "mini",
            "icon": "edit",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editGrade(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改推广员等级")])]
      }
    }], null, false, 1962129208)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handlePage,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "调整上级",
      "visible": _vm.editSuperiorVisible,
      "before-close": _vm.handleCancelSuperior
    },
    on: {
      "update:visible": function($event) {
        _vm.editSuperiorVisible = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": 400,
      "element-loading-text": "数据加载中",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "promoter_grade_name",
      "label": "推广员等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "disabled",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.disabled == '0') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("有效")]) : _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("无效")])]
      }
    }], null, false, 2727238232)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handlePage,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancelSuperior.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitSuperiorAction
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加推广员",
      "visible": _vm.addVisible,
      "distinguishCancelAndClose": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', [_c('el-alert', {
    attrs: {
      "title": "添加的推广员必须为已经授权手机号的会员",
      "type": "info",
      "show-icon": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会员手机号"
    },
    model: {
      value: (_vm.promoter_mobile),
      callback: function($$v) {
        _vm.promoter_mobile = $$v
      },
      expression: "promoter_mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPromoter
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核开通虚拟店",
      "visible": _vm.updateShopVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.updateShopVisible = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label": "审核状态",
        "label-width": "100px"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (_vm.shop_status),
        callback: function($$v) {
          _vm.shop_status = $$v
        },
        expression: "shop_status"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 4
      }
    }, [_vm._v("审核拒绝")])], 1)], 1), _vm._v(" "), (_vm.shop_status == 4) ? _c('el-form-item', {
      attrs: {
        "label": "拒绝原因",
        "label-width": "100px"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 4
      },
      model: {
        value: (_vm.currentRow.reason),
        callback: function($$v) {
          _vm.$set(_vm.currentRow, "reason", $$v)
        },
        expression: "currentRow.reason"
      }
    })], 1) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer content-center",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.actionShopStatus
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改推广员等级",
      "visible": _vm.editGradeVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editGradeVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      staticClass: "grade-setting-row",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      staticClass: "grade-setting-col",
      attrs: {
        "span": 8
      }
    }, [_vm._v(_vm._s(_vm.row.promoter_grade_name))]), _vm._v(" "), _c('el-col', {
      staticClass: "grade-setting-col",
      attrs: {
        "span": 8
      }
    }, [_vm._v("调整为")]), _vm._v(" "), _c('el-col', {
      staticClass: "grade-setting-col",
      attrs: {
        "span": 8
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.newGradeName),
        callback: function($$v) {
          _vm.newGradeName = $$v
        },
        expression: "newGradeName"
      }
    }, _vm._l((_vm.gradeList.grade), function(item) {
      return _c('el-option', {
        key: item.grade_level,
        attrs: {
          "label": item.custom_name,
          "value": item.grade_level
        }
      })
    }), 1)], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer content-center",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitGradeAction
      }
    }, [_vm._v("确定调整")])], 1)
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-632d4c6f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632d4c6f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/popularize/list.vue
// module id = 2779
// module chunks = 0